/**
 * sentenceCase — convert ALL-CAPS Vatican heading strings to a more
 * readable "Sentence Case" form while keeping short Spanish/English
 * connector words lowercase.
 *
 * Used by both the Catechism reading view (H2/H3/H4 banners) and the
 * accordion index, so they read consistently. Kept tiny and inline-safe
 * (no React, no DOM) so it can be imported from anywhere.
 *
 * Behaviour:
 *  - returns the original string when it is fewer than 4 chars
 *  - returns the original string when fewer than 80% of letters are caps
 *    (i.e. already mixed-case prose is left alone)
 *  - otherwise lowercases everything and re-capitalizes word-initial
 *    characters, except for the connectors listed in `LOWERS`.
 */
const LOWERS = new Set([
    // Spanish connectors
    "y", "de", "la", "el", "los", "las", "del", "al", "en", "a", "o", "u",
    "su", "es", "se", "ni", "que", "con", "por", "para",
    // English connectors
    "the", "of", "and", "in", "to", "for", "an", "on", "or", "by",
]);

export function sentenceCase(s) {
    if (!s || s.length < 4) return s || "";
    const letters = s.replace(/[^A-Za-zÁÉÍÓÚÜÑÀÈÌÒÙÂÊÎÔÛáéíóúüñàèìòùâêîôû]/g, "");
    if (!letters) return s;
    const caps = letters.replace(/[a-záéíóúüñàèìòùâêîôû]/g, "");
    if (caps.length / letters.length < 0.8) return s;
    return s.toLowerCase().split(/(\s+|[«»"".,:;])/).map((w, i) => {
        if (!/\w/.test(w)) return w;
        if (i > 0 && LOWERS.has(w)) return w;
        return w.charAt(0).toUpperCase() + w.slice(1);
    }).join("");
}
